import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { header } from '../../portfolio'
import Navbar from '../Navbar/Navbar'
import './Header.css'

const Header = () => {
  const { homepage, title } = header
  const [isScrolled, setIsScrolled] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset
      setIsScrolled(scrollTop > 50)
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <header className={`header ${isScrolled ? 'header--scrolled' : ''}`}>
      <div className="center">
        <h3>
          {homepage ? (
            <Link to="/" className='link'>
              {title}
            </Link>
          ) : (
            title
          )}
        </h3>
        <Navbar />
      </div>
    </header>
  )
}

export default Header
